import React from 'react';
import { ADMIN_PATH, SCHOOL_PATH } from '../config/Constants';

const Users = React.lazy(() => import('../pages/Admin/Users'));
const HotTopicModules = React.lazy(() => import('../pages/HotTopicModules'));
const Dashboard = React.lazy(() => import('../pages/Dashboard'));
const Module = React.lazy(() => import('../pages/Module'));
const Certificate = React.lazy(() => import('../pages/Certificate'));
const Resource = React.lazy(() => import('../pages/Resources'));
const ResourceSingle = React.lazy(() => import('../pages/Admin/ResourceSingle'));
const AddResourcePage = React.lazy(() => import('../pages/Admin/AddResource'));
const ResourceUpdate = React.lazy(() => import('../pages/Admin/ResourceUpdate'));
const StaffDetails = React.lazy(() => import('../pages/School/StaffDetails'));
const SchoolDashboard = React.lazy(() => import('../pages/School/Dashboard'));
const StaffInfo = React.lazy(() => import('../pages/School/StaffInfo/index'));
const AdminResource = React.lazy(() => import('../pages/Admin/Resource'));
const Schools = React.lazy(() => import('../pages/Admin/Schools'));
const AddSchoolPage = React.lazy(() => import('../pages/Admin/AddSchool'));
const UserDetails = React.lazy(() => import('../pages/Admin/UserDetails'));
const AdminDashboard = React.lazy(() => import('../pages/Admin/Dashboard'));

export const userRoutes = [
  {
    path: '/dashboard',
    exact: true,
    element: <Dashboard />,
  },
  {
    path: '/module/:moduleid',
    exact: true,
    element: <Module />,
  },
  {
    path: '/resource',
    exact: true,
    element: <Resource />,
  },
  {
    path: '/hot-topics-modules/:moduleid',
    exact: true,
    element: <HotTopicModules />,
  },
  {
    path: '/certificate',
    exact: true,
    element: <Certificate />,
  },
];

export const adminRoutes = [
  {
    path: `${ADMIN_PATH}/dashboard`,
    exact: true,
    element: <AdminDashboard />,
  },
  {
    path: `${ADMIN_PATH}/resource`,
    exact: true,
    element: <AdminResource />,
  },
  {
    path: `${ADMIN_PATH}/add-school`,
    exact: true,
    element: <AddSchoolPage />,
  },
  {
    path: `${ADMIN_PATH}/resource-single/:id`,
    exact: true,
    element: <ResourceSingle />,
  },
  {
    path: `${ADMIN_PATH}/add-resource`,
    exact: true,
    element: <AddResourcePage />,
  },
  {
    path: `${ADMIN_PATH}/update-resource/:id`,
    exact: true,
    element: <ResourceUpdate />,
  },
  {
    path: `${ADMIN_PATH}/users`,
    exact: true,
    element: <Users />,
  },
  {
    path: `${ADMIN_PATH}/schools`,
    exact: true,
    element: <Schools />,
  },
  {
    path: `${ADMIN_PATH}/users/:id`,
    exact: true,
    element: <UserDetails />,
  },
];

export const schoolAdminRoutes = [
  {
    path: `${SCHOOL_PATH}/dashboard`,
    exact: true,
    element: <SchoolDashboard />,
  },
  {
    path: `${SCHOOL_PATH}/staff`,
    exact: true,
    element: <StaffDetails />,
  },
  {
    path: `${SCHOOL_PATH}/staff/:id`,
    exact: true,
    element: <StaffInfo />,
  },
];
